import revive_payload_client_4sVQNw7RlN from "/home/homeyou/shc/build/build-headless/101573/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/home/homeyou/shc/build/build-headless/101573/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/home/homeyou/shc/build/build-headless/101573/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/home/homeyou/shc/build/build-headless/101573/node_modules/nuxt/dist/app/plugins/payload.client.js";
import plugin_vue3_A0OWXRrUgq from "/home/homeyou/shc/build/build-headless/101573/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/home/homeyou/shc/build/build-headless/101573/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/home/homeyou/shc/build/build-headless/101573/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_eTVJQYlCmx from "/home/homeyou/shc/build/build-headless/101573/node_modules/@nuxtjs/apollo/dist/runtime/plugin.mjs";
import plugin_t2GMTTFnMT from "/home/homeyou/shc/build/build-headless/101573/node_modules/@nuxtjs/device/dist/runtime/plugin.mjs";
import formkitPlugin_pZqjah0RUG from "/home/homeyou/shc/build/build-headless/101573/.nuxt/formkitPlugin.mjs";
import composition_sLxaNGmlSL from "/home/homeyou/shc/build/build-headless/101573/node_modules/@nuxtjs/i18n/dist/runtime/plugins/composition.mjs";
import i18n_yfWm7jX06p from "/home/homeyou/shc/build/build-headless/101573/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.mjs";
import chunk_reload_client_UciE0i6zes from "/home/homeyou/shc/build/build-headless/101573/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import _01_ready_nuxt_nM5hqFd4s4 from "/home/homeyou/shc/build/build-headless/101573/node_modules/@shc/nuxt-shc-base-layer/plugins/01-ready-nuxt.ts";
import _02_event_bus_XHUyZS4o8v from "/home/homeyou/shc/build/build-headless/101573/node_modules/@shc/nuxt-shc-base-layer/plugins/02-event-bus.ts";
import _03_apollo_config_WjK4cFYgjn from "/home/homeyou/shc/build/build-headless/101573/node_modules/@shc/nuxt-shc-base-layer/plugins/03-apollo-config.ts";
import notification_42zW3iTXrC from "/home/homeyou/shc/build/build-headless/101573/layers/nuxt-bbk-notification-layer/plugins/notification.ts";
import gtm_client_pBlAMVo1qj from "/home/homeyou/shc/build/build-headless/101573/layers/nuxt-bbk-gtm-layer/plugins/gtm.client.ts";
import sentry_client_shVUlIjFLk from "/home/homeyou/shc/build/build-headless/101573/plugins/sentry.client.ts";
import vue3_touch_events_3JrctwDJKG from "/home/homeyou/shc/build/build-headless/101573/plugins/vue3-touch-events.ts";
import account_client_PoI7KqU13k from "/home/homeyou/shc/build/build-headless/101573/plugins/account.client.ts";
import custom_events_client_5fhDMANZlB from "/home/homeyou/shc/build/build-headless/101573/plugins/custom-events.client.ts";
import facebook_client_CFH3L0Sd4I from "/home/homeyou/shc/build/build-headless/101573/plugins/facebook.client.ts";
import footer_newsletter_subscription_client_lTQWYV3EeQ from "/home/homeyou/shc/build/build-headless/101573/plugins/footer-newsletter-subscription.client.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_eTVJQYlCmx,
  plugin_t2GMTTFnMT,
  formkitPlugin_pZqjah0RUG,
  composition_sLxaNGmlSL,
  i18n_yfWm7jX06p,
  chunk_reload_client_UciE0i6zes,
  _01_ready_nuxt_nM5hqFd4s4,
  _02_event_bus_XHUyZS4o8v,
  _03_apollo_config_WjK4cFYgjn,
  notification_42zW3iTXrC,
  gtm_client_pBlAMVo1qj,
  sentry_client_shVUlIjFLk,
  vue3_touch_events_3JrctwDJKG,
  account_client_PoI7KqU13k,
  custom_events_client_5fhDMANZlB,
  facebook_client_CFH3L0Sd4I,
  footer_newsletter_subscription_client_lTQWYV3EeQ
]